import { useFormMutation } from "@/hooks/useFormMutation";
import { fetcher, sendData } from "@/services/api/fetcher";
import { ApiResponse, DataObject, DataPaginate } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { PositionFormPayload } from "./validation";

// get
const getPosition = async (
  query?: string
): Promise<ApiResponse<DataPaginate<PositionResponse>>> => {
  return await fetcher(query ? `master/posisi?${query}` : `master/posisi`);
};

export const useGetPosition = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<PositionResponse>>, Error>(
    ["useGetPosition", query],
    () => getPosition(query),
    {
      keepPreviousData: true,
      refetchIntervalInBackground: true,
    }
  );
};

// get by id
export const getPositionId = async (
  id: number
): Promise<ApiResponse<DataObject<PositionResponse>>> => {
  return await fetcher(`master/posisi/${id}`);
};

export const useGetPositionId = (id: number) => {
  return useQuery<ApiResponse<DataObject<PositionResponse>>, Error>(
    ["useGetPositionId", id],
    () => getPositionId(id)
  );
};

// post
export const usePosition = (method: "POST" | "PUT" = "POST", id?: number) => {
  return useFormMutation<
    ApiResponse<DataObject<PositionFormPayload>>,
    Error,
    PositionFormPayload
  >({
    mutationFn: async (
      data
    ): Promise<ApiResponse<DataObject<PositionFormPayload>>> => {
      const endpoint = id ? `master/posisi/${id}` : "master/posisi";
      const delay = new Promise((resolve) => setTimeout(resolve, 2000));
      const response: ApiResponse<DataObject<PositionFormPayload>> =
        await sendData(endpoint, data, method);
      await delay;
      return response;
    },
    loadingMessage:
      method === "POST" ? "Menyimpan data..." : "Memperbarui data...",
    successMessage:
      method === "POST"
        ? "Data berhasil ditambahkan"
        : "Data berhasil diperbarui",
  });
};
